// Centralized business configuration
export const businessConfig = {
  name: 'Florida Blu Pools LLC',
  tagline: 'Professional Pool Service',
  phone: {
    primary: '(305) 923-1326',
    secondary: '(754) 551-1014',
    primaryRaw: '+13059231326',
    secondaryRaw: '+17545511014'
  },
  email: 'info@floridabluepools.com',
  serviceArea: {
    counties: ['Broward County', 'Miami-Dade County'],
    state: 'Florida',
    full: 'Broward & Miami-Dade Counties, Florida'
  },
  hours: '24/7 - Open 24 Hours',
  social: {
    facebook: '',
    instagram: '',
    linkedin: ''
  },
  credentials: [
    'Licensed & Insured',
    'Residential & Commercial',
    'Weekly Service Routes',
    'Equipment Repair Experts'
  ],
  services: {
    residential: [
      'Weekly maintenance visits',
      'Chemical balancing & testing',
      'Equipment inspection',
      'Debris removal & cleaning',
      'Personalized service plans'
    ],
    commercial: [
      'Multi-property scheduling',
      'Compliance & reporting',
      'Preventative maintenance',
      'Emergency response available',
      'Detailed service documentation'
    ],
    core: [
      {
        name: 'Pool Cleaning',
        description: 'Thorough cleaning of pool surfaces, walls, and floors',
        icon: 'ri-brush-line'
      },
      {
        name: 'Chemical Balancing',
        description: 'Precise water chemistry testing and adjustment',
        icon: 'ri-flask-line'
      },
      {
        name: 'Routine Inspections',
        description: 'Regular equipment checks and maintenance assessments',
        icon: 'ri-search-eye-line'
      },
      {
        name: 'Equipment Checks',
        description: 'Filter, pump, and system performance monitoring',
        icon: 'ri-tools-line'
      }
    ]
  },
  expertise: {
    climate: [
      'High-heat chemical stabilization',
      'Rainfall dilution management',
      'Year-round algae prevention',
      'Equipment wear monitoring',
      'Saltwater optimization for coastal conditions'
    ],
    scheduling: {
      residential: [
        'Fixed weekly routes',
        'Same service day each week',
        'Weather-adjusted follow-ups'
      ],
      commercial: [
        'Multi-property scheduling',
        'Visit tracking',
        'Service documentation'
      ]
    },
    repairs: {
      pumpsMotors: [
        'Variable-speed pump diagnostics',
        'Motor seal & bearing failures',
        'Electrical & capacitor issues',
        'Energy-efficiency upgrades'
      ],
      filters: [
        'Pressure & flow issues',
        'Cracked housings',
        'Grid replacements',
        'Deep clean servicing'
      ],
      heaters: [
        'Igniters & sensors',
        'Flow & pressure switches',
        'Startup & safety inspections',
        'Efficiency assessments'
      ],
      valvesPlumbing: [
        'Diverter valves',
        'Suction & return diagnostics',
        'Equipment-side leak detection'
      ],
      automation: [
        'Pentair / Hayward / Jandy systems',
        'Timer installs',
        'Salt cell diagnostics & cleaning',
        'Error-code troubleshooting'
      ]
    }
  },
  repairProcess: [
    {
      step: 1,
      title: 'On-site Equipment Inspection',
      description: 'Thorough evaluation of your pool equipment and systems'
    },
    {
      step: 2,
      title: 'Clear Diagnosis & Explanation',
      description: 'We explain the issue in plain language and show you what needs attention'
    },
    {
      step: 3,
      title: 'Upfront Pricing Approval',
      description: 'No surprises - you approve the cost before we begin any work'
    },
    {
      step: 4,
      title: 'OEM-Grade Repair',
      description: 'Quality parts and professional installation with warranty backing'
    }
  ]
};
